import React from "react";

const ShapMobile2 = () => {
	return (
		<svg width={258} height={254} viewBox="0 0 258 254" fill="none">
			<g filter="url(#filter0_f_34_83)">
				<path
					d="M150.813 28.3823C151.982 71.1577 187.607 104.886 230.382 103.717C273.157 102.547 306.886 66.9236 305.716 24.1477C304.547 -18.6274 268.923 -52.3558 226.148 -51.1866C183.372 -50.0173 149.644 -14.3931 150.813 28.3823Z"
					fill="url(#paint0_radial_34_83)"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_34_83"
					x="0.783203"
					y="-201.216"
					width="454.963"
					height="454.962"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={75}
						result="effect1_foregroundBlur_34_83"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_34_83"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(207.137 202.763) rotate(-89.8609) scale(358.073 325.155)"
				>
					<stop offset="0.34394" stopColor="#00EBFF" />
					<stop offset="0.619147" stopColor="#FF39B0" />
					<stop offset="0.974236" stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default ShapMobile2;
